

























































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { EditDayChangePicker, NumberInput }
})
export default class OtherMedical3 extends Vue {
  @Prop() tab!: MedicalSpecification;
}
